import { render, staticRenderFns } from "./topicZero.vue?vue&type=template&id=d9998f32&scoped=true&"
import script from "./topicZero.vue?vue&type=script&lang=js&"
export * from "./topicZero.vue?vue&type=script&lang=js&"
import style0 from "./topicZero.vue?vue&type=style&index=0&id=d9998f32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9998f32",
  null
  
)

export default component.exports